import moment from "moment";

import { HighPriorityIndicator } from "@/Common/Components/IconControls/HighPriorityIndicator";
import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { MessageTaskViewContainer } from "@/Communications/Components/MessageTaskView/MessageTaskViewContainer";
import { CommunicationsHelper } from "@/Communications/Helpers/CommunicationsHelper";
import { PatientTaskListItem } from "@/Patient/Models/History/PatientTaskListItem";
import { IPatientTasksModel } from "@/Patient/Models/UI/History/IPatientTasksModel";

interface IPatientHistoryTasksProps {
    Model: IPatientTasksModel;
}

class TasksView extends React.Component<IPatientHistoryTasksProps, any> {
    public render(): JSX.Element {
        var taskModel: IPatientTasksModel;
        if (this.props.Model)
            taskModel = this.props.Model;

        return (
            <div className="medical-summary-container">
                <div className="tb medical-summary">
                    {this.leftSide(taskModel)}
                    {taskModel.get("ShowDetails") === true && this.rightSide(taskModel)}
                    {taskModel.get("ShowDetails") === false && this.emptyRightSide()}
                </div>
            </div>
        );
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public componentDidMount(): void {
        sessionStore.dispatchAsync(LocalPatientOperations.History.Task_LoadPatientTask);

        $(window).trigger("resize");
    }

    private leftSide(model: IPatientTasksModel): JSX.Element {
        var toggleIconCss = "toggle-icon2";
        if (this.props.Model.get("NotCompletedOnly")) {
            toggleIconCss += " active";
        }
        return (
            <div className="fxheight tbc full-border left-primary">
                <div className="note-search">
                    <div className="header" />
                    <div className="search-field">
                        <div className="gf">
                            <span className="glyphicon glyphicon-search" />
                        </div>
                        <TextboxControl debounceMs={400} value={model.get("SearchText")} className="fullWidth" dataCy="tasksView-search" operation={LocalPatientOperations.History.Task_SearchText} placeholder={cacheStore.GetString("SearchLabel")} />
                    </div>
                    {model.get("IsCriteriaExpanded") === true && (
                        <div style={{ marginTop: "10px" }}>
                            <MultiDateSelector
                                id="doc_search_date_selector"
                                fullWidth={true}
                                fromMyleOperation={LocalPatientOperations.History.Task_FromDateChanged}
                                toMyleOperation={LocalPatientOperations.History.Task_ToDateChanged}
                                fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                from={model.get("DateFrom")}
                                to={model.get("DateTo")}
                            />
                        </div>
                    )}
                    <div className="clearfix" style={{ marginTop: "15px" }}>
                        <span style={{ marginRight: "7px" }} className={toggleIconCss} onClick={this.toggleDisplayMode.bind(this)} />
                        {model.get("IsCriteriaExpanded") === true && <a className="pull-right" onClick={this.ShowCriteria.bind(this)}>[-]{cacheStore.GetString("CriteriaLabel")}</a>}
                        {model.get("IsCriteriaExpanded") === false && <a className="pull-right" onClick={this.ShowCriteria.bind(this)}>[+]{cacheStore.GetString("CriteriaLabel")}</a>}
                    </div>
                </div>
                {this.taskList(model)}
            </div>
        );
    }

    private taskList(model: IPatientTasksModel): JSX.Element {
        var taskList = model.get("TaskList").toArray();

        if (this.props.Model.get("NotCompletedOnly") != null && this.props.Model.get("NotCompletedOnly") == true) {
            taskList = taskList.filter(x => {
                const completedLookupId = cacheStore.FindLookupByLookupCode("Completed", "TaskStatus").LookupID;
                return x.GenericTaskStatusId?.toLowerCase() !== completedLookupId?.toLowerCase();
            });
        }

        var taskRender = taskList.map((task: PatientTaskListItem, idx: number) => {
            var date = ((task.Model.SendDate != null) ? moment(task.Model.SendDate).format("YYYY/MM/DD") : "--");
            var dueDate = ((task.Model.DueDate != null) ? moment(task.Model.DueDate).format("YYYY/MM/DD") : "--");

            var taskColor = CommunicationsHelper.determineOverallStatusColor(task.GenericTaskStatusId, task.Model.DueDate);
            const completedLookupId = cacheStore.FindLookupByLookupCode("Completed", "TaskStatus").LookupID;
            const isCompleted = task.GenericTaskStatusId?.toLowerCase() === completedLookupId?.toLowerCase();

            return (
                <div style={{ color: taskColor }} className="pointer" key={"__a" + idx} onClick={this.setSelectedTask.bind(this, task)}>
                    <div className="med-note">
                        <div className="tb">
                            <div className="tbc">
                                <p className="ellipsis"><strong>{task.Model.Subject}</strong></p>
                                <p><span>{task.Model.FromEmployee}</span></p>
                                <p><span>{cacheStore.GetString("DueDateLabel") + " : "} </span><span> {dueDate}</span></p>
                            </div>
                            <div className="tbc text-right">
                                <p><span>{date}</span></p>
                                <p><span>{cacheStore.GetString("PriorityLabel")}</span><span> {task.Model.Priority} {!isCompleted && cacheStore.IsHighPriority(task.Model.PriorityLookupId) && <HighPriorityIndicator />}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
        return (
            <div data-hvar="40" className="note-collection scrollable" data-cy="tasksView-taskList">
                {taskRender}
            </div>
        );
    }

    private rightSide(model: IPatientTasksModel): JSX.Element {
        let individualMessageId = model.get("IM_ID");
        if (!individualMessageId)
            return null;

        return (
            <MessageTaskViewContainer
                individualMessageId={individualMessageId}
                title={cacheStore.GetString("MessageDetailsLabel")}
                showPatientBanner={false}
                showAddNoteControl
                showFullWidth
                className="pad-left-15 pad-right-15"
            />
        );
    }

    private emptyRightSide(): JSX.Element {
        return (
            <div className="tbc right-primary">
                <div className="scrollable">
                    <div className="summary-container no-border" />
                </div>
            </div>
        );
    }

    public ShowCriteria(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Task_CriteriaClick);
    }

    public setSelectedTask(task: PatientTaskListItem): void {
        var operation = new LocalEvent(LocalPatientOperations.History.Task_ShowSelectedTask);
        operation.AddItem("task", task);
        LocalEventDispatcher.dispatch(operation);
    }

    public toggleDisplayMode(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Task_ToggleListDisplayMode);
    }
}

export { TasksView };
